module.exports = __webpack_public_path__ + "static/media/car5.2eb99e19.jpg";